let confirmationResultStore = null;

export const setConfirmationResultStore = (value) => {
  confirmationResultStore = value;
};

export { confirmationResultStore };
